import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL_DOCS, LEGAL_LINKS, LEGAL_UPDATED } from "@/lib/legal";
import { LEGAL_SELLER } from "@/lib/brand";

export default function Legal() {
    const { doc } = useParams();
    const navigate = useNavigate();
    const data = LEGAL_DOCS[doc] || LEGAL_DOCS.terms;

    return (
        <div className="min-h-screen bg-white" data-testid="legal-page">
            <div className="border-b border-slate-200 bg-navy px-4 py-4 text-white lg:px-8">
                <div className="mx-auto flex max-w-4xl items-center justify-between">
                    <span className="font-heading text-sm font-bold">Smarter Choice · Policies</span>
                    <button onClick={() => navigate("/")} data-testid="legal-home-btn" className="inline-flex items-center gap-1.5 text-sm text-white/90 hover:text-white">
                        <ArrowLeft className="h-4 w-4" /> Back to site
                    </button>
                </div>
            </div>

            <div className="mx-auto max-w-4xl px-4 py-10 lg:px-8">
                <nav className="mb-8 flex flex-wrap gap-2" aria-label="Policies">
                    {LEGAL_LINKS.map((l) => (
                        <Link key={l.slug} to={`/legal/${l.slug}`} data-testid={`legal-tab-${l.slug}`}
                            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${l.slug === data.slug ? "bg-navy text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
                            {l.label}
                        </Link>
                    ))}
                </nav>

                <h1 className="font-heading text-3xl font-bold text-navy sm:text-4xl" data-testid="legal-title">{data.title}</h1>
                <p className="mt-2 text-sm text-slate-500">Last updated {LEGAL_UPDATED} · {LEGAL_SELLER}</p>
                <p className="mt-5 text-base leading-relaxed text-slate-700">{data.intro}</p>

                <div className="mt-8 space-y-7">
                    {data.sections.map((s) => (
                        <section key={s.h}>
                            <h2 className="font-heading text-lg font-bold text-navy">{s.h}</h2>
                            {s.body.map((p, i) => (
                                <p key={i} className="mt-2 text-sm leading-relaxed text-slate-700">{p}</p>
                            ))}
                        </section>
                    ))}
                </div>

                <p className="mt-10 border-t border-slate-200 pt-6 text-xs leading-relaxed text-slate-500">
                    These policies are provided for transparency and are subject to ongoing qualified legal review. They do not replace any service agreement or required standalone disclosure, which govern where applicable.
                </p>
            </div>
        </div>
    );
}
